export enum MembershipEnum {
  Basic = 'basic',
  Pro = 'pro',
}
